// import Categories from '../../api/funnels/Categories.js'

// initial state
const state = {
    current: false 
}

// getters
const getters = {

    current(state){
        return state.current
    },

}

// actions
const actions = {



}

// mutations
const mutations = {

    SET_USER(state, user) {

        // console.log(user);

        let current = {};

        if(user.uid){

            let displayName = user.displayName ;

            if(!displayName){
                displayName = user.email ;
            }

            if(!displayName){
                displayName = user.uid ;
            }

            current = {
                loggedin: true,
                displayName: displayName,
                email: user.email,
                uid: user.uid,
                refreshToken: user.refreshToken,
                photoURL: user.photoURL,
                emailVerified: user.emailVerified,
                meta: null
            }

        }else{

            current = {
                loggedin: false
            }

        }

        state.current = current ;
        
        this.commit("app/hideOverlay") ;

    },
    set_email(state, email) {

        state.current.email = email ;
        
    },

    update_user(state, api_user){
        
        state.current.id = api_user.id;
        state.current.meta = api_user.meta;

    }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}